// External API Configuration
export const EXTERNAL_API_CONFIG = {
  // Authentication URL
  AUTH_URL: import.meta.env.VITE_EXTERNAL_API_AUTH_URL || "https://testsmakers.com:8092/api/Authentication/authenticate",

  // Base URL for the external API
  BASE_URL: import.meta.env.VITE_EXTERNAL_API_BASE_URL || "https://testsmakers.com:8092",

  // Endpoint to get customer by identification
  CUSTOMER_BY_IDENTIFICATION_ENDPOINT: "/api/Customer/GetCustomerByIdentification",

  // Endpoint to execute SP Demo.InsertarOperacionesBursatiles
  EXECUTE_SP_ENDPOINT: "/api/Demo/execute",

  // Credentials - Use environment variables
  USERNAME: import.meta.env.VITE_EXTERNAL_API_USERNAME || "Administrador",
  PASSWORD: import.meta.env.VITE_EXTERNAL_API_PASSWORD || "Administrador123*",

  // Token storage keys
  TOKEN_KEY: "external_api_token",
  TOKEN_EXPIRY_KEY: "external_api_token_expiry",
};
